import styled from 'styled-components/macro';
import { getRiskColor } from 'common/utils';

export const StyledRiskIndicator = styled.div`
  border-radius: 50%;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${({ score }) => getRiskColor(score)};
`;
